export async function getMerchantData(domain) {
  const response = await fetch(
    "https://2cwxraxcb6.execute-api.ap-southeast-1.amazonaws.com/dev/merchant?domain=" +
      domain
  );
  const jsonData = await response.json();
  return { ...jsonData, status: response.status };
}
